/**
 * Helpers d'affichage d'un formateur, robustes aux deux types :
 * - `independant` : identité « Prénom Nom »
 * - `organisme`   : raison sociale (`nomStructure`), `prenom`/`nom` étant `null`
 *
 * Indispensable partout où l'on consomme un formateur de type inconnu (messagerie,
 * threads) : un accès direct à `prenom[0]` sur un organisme lève une TypeError.
 */

/**
 * Nom d'affichage : « Prénom Nom » pour un indépendant, raison sociale pour un
 * organisme. Repli sur l'email puis « Formateur ».
 */
export function formateurDisplayName(formateur) {
  if (!formateur) return ''
  if (formateur.type === 'independant') {
    const full = `${formateur.prenom || ''} ${formateur.nom || ''}`.trim()
    if (full) return full
  } else if (formateur.nomStructure) {
    return formateur.nomStructure
  }
  return formateur.email || 'Formateur'
}

/**
 * Initiales (1 à 2 lettres) dérivées du nom d'affichage, pour un avatar.
 * Null-safe : ne suppose jamais que prénom/nom existent.
 */
export function formateurInitials(formateur) {
  const parts = formateurDisplayName(formateur).split(/\s+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  return (parts[0]?.slice(0, 2) || '?').toUpperCase()
}
